export default __webpack_public_path__ + "static/media/Armbands of the First Circle.90f6f9ec.jpg";